import React from 'react';
import { Router } from '@gatsbyjs/reach-router';
import { ThemeProvider } from '@material-ui/styles';
import { useMediaQuery, useTheme } from '@material-ui/core';
import { useSelector } from 'react-redux';

import { NotFoundPage, Orders } from '@views';
import { PrivateRoute } from '@components';
import { lucidTheme } from '@components/FullPageLayout/lucidTheme';
import { PAYMENT_PAGE_ENABLED } from '@constants';
import { PublicRoute } from '@components';
import LeadCollectionPage from '@views/SelfService/LeadCollector/LeadCollectionPage';

export const FullPageLayout = ({ location, basepath, ...props }) => {
  const theme = useTheme();
  const isWebdevMobile = useMediaQuery(theme.breakpoints.down(812));
  const { isLoading } = useSelector(({ appState }) => appState);
  return (
    <ThemeProvider theme={lucidTheme}>
      {!isLoading && (
        <Router primary={false} location={location} basepath={basepath}>
          <PublicRoute
            path="/interested"
            component={LeadCollectionPage}
            isWebdevMobile={isWebdevMobile}
            basepath={basepath}
            location={location}
            {...props}
          />
          {PAYMENT_PAGE_ENABLED && (
            <PrivateRoute
              path="/*"
              component={Orders}
              isWebdevMobile={isWebdevMobile}
              basepath={basepath}
              location={location}
              {...props}
            />
          )}
          <PublicRoute default component={NotFoundPage} />
        </Router>
      )}
    </ThemeProvider>
  );
};
